import { CULTURE_CURRENCY, CULTURE_INFO } from 'globalconfig';
var createCurrencyFormatter = function (val, fractionSize, showZero, c) {
    if (val === void 0) { val = 0; }
    if (fractionSize === void 0) { fractionSize = 2; }
    if (showZero === void 0) { showZero = true; }
    if (c === void 0) { c = CULTURE_CURRENCY; }
    if (isNaN(val))
        return '';
    if (!showZero && val === 0)
        return '';
    return new Intl.NumberFormat(CULTURE_INFO, {
        style: 'currency',
        currency: c,
        minimumFractionDigits: fractionSize,
        maximumFractionDigits: 2
    }).format(val);
};
export var currencyFormatter = function (val, c) {
    if (val === void 0) { val = 0; }
    if (c === void 0) { c = CULTURE_CURRENCY; }
    return createCurrencyFormatter(val, 2, false, c);
};
export var currencyFormatterFraction = function (val, fractionSize, showZero, c) {
    if (val === void 0) { val = 0; }
    if (fractionSize === void 0) { fractionSize = 0; }
    if (showZero === void 0) { showZero = true; }
    if (c === void 0) { c = CULTURE_CURRENCY; }
    return createCurrencyFormatter(val, fractionSize, showZero, c);
};
